
    import Vue from "vue";

    const END_POINT = "/teacher";

    const createTeacher = (teacher) => Vue.axios.post(END_POINT+'/update',  teacher );

    export {
      createTeacher
    };
    